<template>
  <form
    :name="name"
    novalidate
    @submit.prevent="submitForm"
  >
    <slot />
  </form>
</template>

<script>
export const FormProvider = 'TrFormProvider';

export default {
  name: 'TrForm',
  provide() {
    return {
      [FormProvider]: {
        register: vm => {
          const id = Symbol();
          this.formInputs[id] = vm;
          return () => delete this.formInputs[id];
        }
      }
    };
  },
  props: ['onValidSubmit', 'onInvalidSubmit', 'name', 'hideErrosUntilIsDirty'],
  data: () => ({
    formInputs: {},
    isSubmitting: false,
    isSubmitted: false
  }),
  methods: {
    submitForm() {
      this.isSubmitted = true;
      if (!this.isSubmitting) {
        this.areInputsValid().then(areValid => {
          if (areValid) {
            if (typeof this.onValidSubmit === 'function') {
              this.onValidSubmit();
            }
          } else if (typeof this.onInvalidSubmit === 'function') {
            this.onInvalidSubmit();
          }
        });
        this.isSubmitting = false;
      }
    },
    resetSubmit() {
      this.isSubmitted = false;
    },
    setAsSubmitted() {
      this.isSubmitted = true;
    },
    markFormFieldsAsDirty() {
      this.getInputs().forEach(input => {
        input.setAsDirty();
      });
    },
    isDirty() {
      return this.getInputs().every(input => !input.isDirty);
    },
    areInputsValid() {
      let isFormValid = true;
      const inputs = this.getInputs();
      const promises = [];

      inputs.forEach(input => {
        promises.push(input.validateInputAsync(input.modelValue).then(() => {}, () => {
          isFormValid = false;
        }));
      });

      return Promise.all(promises).then(() => isFormValid);
    },
    getInputs() {
      return Object.getOwnPropertySymbols(this.formInputs)
        .map(key => this.formInputs[key])
        .filter(vm => vm.$options.name === 'TrTextField');
    }
  }
};
</script>
